<template lang="pug">
  main#main.account-profile
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-user')
      section.l-section
        .l-section-h
          b-row.mb-5
            b-col
              router-view
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'account-profile',
  components: {
    WcBreadcrumb,
  },
}
</script>
